const appConfig = {
  // apiPrefix: "http://localhost:5002/api/v1/web",
  // base URL --> https://api-western.5techg.com/api
  // apiPrefix: "https://vm.5techg.com/api/v1/web",
  apiPrefix: "https://western.distributor.in.vaishnaviprofile.com/api/v1/web",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: true,
};

export default appConfig;
